import {
  Form,

  FormInputProps,
  AutoCompleteProps,
  ICON_MAGNIFY,
  ICON_MAP_MARKER,
} from '@doveit/lego';
import React, { FunctionComponent } from 'react';
import { getAddressSuggestions, AddressSuggestion } from '../../services/geo/geo';
import AutocompleteSuggestion from '../autocomplete-suggestion/AutocompleteSuggestion';
import * as styles from './FormAddressAutoComplete.style';
import { GoogleMapsContext } from '../../contexts/google-map-context/GoogleMapsContext';
import { requireFromStaticAsset } from '../../utils/assetsUtils';

const renderSuggestion = (result: AddressSuggestion) => (
  <AutocompleteSuggestion
    icon={ICON_MAP_MARKER}
    label={result.description}
  />
);

const printSuggestion = (result: AddressSuggestion) => result.description;

const renderSuggestionsListFooter = () => (
  <div css={styles.suggestionFooter}>
    <img
      src={requireFromStaticAsset('powered-by-google.png')}
      alt="Powered by Google"
    />
  </div>
);

export const fetchSuggestions = (
  geoApiKey: string,
  sessionToken: google.maps.places.AutocompleteSessionToken,
) => (value) => getAddressSuggestions(geoApiKey, value, { sessionToken });

// as we internally specify all props that FormAutoCompleteProps has in addition to FormInputProps,
// we simply ask to our consumers to give us FormInputProps
export type FormAddressAutoCompleteProps = FormInputProps & Pick<AutoCompleteProps<AddressSuggestion>, 'onSuggestionSelected'>;

const FormAddressAutoComplete: FunctionComponent<FormAddressAutoCompleteProps> = ({
  ...rest
}) => (
  <GoogleMapsContext.Consumer>
    {({ apiKey, sessionToken }) => (
      <Form.AutoComplete
        {...rest}
        icon={ICON_MAGNIFY}
        suggestions={fetchSuggestions(apiKey, sessionToken)}
        printSuggestion={printSuggestion}
        render={{
          suggestion: renderSuggestion,
          suggestionsListFooter: renderSuggestionsListFooter,
        }}
      />
    )}
  </GoogleMapsContext.Consumer>
);

export default FormAddressAutoComplete;
